import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';

export class AssetStorageDownloadUrl extends PrimitiveValueObject<string> {
  static create(value: string): AssetStorageDownloadUrl {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AssetStorageDownloadUrl(value);
  }
}
